import React from 'react';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/BaseOverride';
import ACHTransferTemplateContent from './Content';

const ACHTransferTemplate = ({
  resource,
}) => {
  const [fullLiquidation, setFullLiquidation] = React.useState(resource.attr('fullLiquidation'));
  const onChange = (attr, value) => {
    if (attr === 'fullLiquidation') {
      setFullLiquidation(value);
    }
  };

  return (
    <WizardStepWrapperTemplate
      submitConfirmation={fullLiquidation === 'true'}
      submitConfirmationTitle={resource?.attr('fullLiquidationConfirmationTitle')}
      submitConfirmationMessage={resource?.attr('fullLiquidationConfirmationMessage')}
      submitConfirmationButtonLabel={resource?.attr('fullLiquidationConfirmationPrimaryActionLabel')}
      resource={resource}
      layout={ACHTransferTemplateContent}
      primaryActionLabel={'Submit Transfer'}
      LayoutProps={{
        resource,
        onChange,
      }}
      metaOverrideSet={BaseOverride}
      hideErrors
    />
  );
};
ACHTransferTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ACHTransferTemplate;
